import { t } from "i18next";
import { DefaultRecordingTemplates } from "@/common/enums/enums";

// The three built-in templates are stored and sent to the API by their
// English name ("SOAP Template"); only what the clinician reads is
// translated. Any other name (a custom template, a letter) is shown as is.
const BUILT_IN_LABEL_KEYS: Record<string, string> = {
  [DefaultRecordingTemplates.SOAP]: "templates.builtIn.soap",
  [DefaultRecordingTemplates.SPECIALIST]: "templates.builtIn.specialist",
  [DefaultRecordingTemplates.VOICE_TO_TEXT]: "templates.builtIn.voiceToText",
};

export const builtInTemplateLabel = (name: string): string => {
  const key = BUILT_IN_LABEL_KEYS[name];
  return key ? t(key, { defaultValue: name }) : name;
};

// A visit document's name as the clinician knows it. A note written with one
// of the clinician's own templates is stored with the template "Custom"; its
// real name comes from the template (customTemplateName). Built-in templates
// ("SOAP", "Referral Letter"...) keep their stored name, translated for the
// three built-in visit templates.
export const documentTemplateName = (doc: {
  template?: string | null;
  customTemplateName?: string | null;
}): string | null =>
  doc.customTemplateName?.trim() ||
  (doc.template ? builtInTemplateLabel(doc.template) : null);
